import React from 'react';
import {
  Button,
  ButtonGroup,
  DropdownButton,
  Modal,
} from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import * as Fi from 'react-icons/fi';

import { JournalTransaction } from 'services/action';
import { Table } from 'services/action';

const initialState = {
  isDelete: false,
};

const Action = ({ data }) => {
  const Dispatch = useDispatch();
  const StateLoading = useSelector(
    (state) => state?.Activity?.services['JournalTransaction.Delete']
  );
  const StateTable = useSelector((state) => state?.Table?.data['transaction_journal']);

  const [{ isDelete }, setState] = React.useState(initialState);

  const $handleClose = () => {
    setState((prevState) => ({ ...prevState, isDelete: false }));
  };

  const $handleDelete = async () => {
    const del = await Dispatch(JournalTransaction.$delete(data?.id));
    if (del?.message === 'success') {
      $handleClose();
      Dispatch(Table.$reload('transaction_journal', StateTable));
    }
  };

  return (
    <>
      <DropdownButton
        as={ButtonGroup}
        variant="transparent"
        size="md"
        className="no-carret tbl-action"
        title={<Fi.FiMoreVertical size={13} color="gray" />}
      >
        <Link
          className="dropdown-item d-flex align-items-center"
          role="button"
          to={`/accounting/transaction/update/${data?.id}`}
        >
          <Fi.FiEdit size={15} color="#202020" className="me-2" />
          Perbaharui
        </Link>

        <button
          className="dropdown-item d-flex align-items-center"
          onClick={() =>
            setState((prevState) => ({ ...prevState, isDelete: true }))
          }
        >
          <Fi.FiTrash2 size={15} className="me-2" />
          Hapus
        </button>
      </DropdownButton>

      {/* modal delete */}
      <Modal
        show={isDelete}
        onHide={$handleClose}
        backdrop="static"
        centered
        className="text-center"
        size="small"
      >
        <Modal.Body>
          <div className="btn-close" onClick={$handleClose} />
          <div className="modal-status bg-danger" />
          <Fi.FiAlertTriangle className="mb-2 text-danger" size={90} />
          <h3>Anda yakin?</h3>
          <p className="text-danger fw-semibold">
            Data yang sudah dihapus tidak bisa dipulihkan
          </p>

          {/* {isError ? (
            <div className="invalid-feedback" style={{ display: 'block' }}>
              {isError?.id}
            </div>
          ) : null} */}
        </Modal.Body>
        <Modal.Footer>
          <div className="row w-100">
            <div className="col">
              <Button
                variant="white"
                className="w-100"
                onClick={$handleClose}
              >
                Batal
              </Button>
            </div>
            <div className="col">
              <Button
                variant="danger"
                className={StateLoading ? ' btn-loading w-100' : 'w-100'}
                onClick={$handleDelete}
                disabled={StateLoading}
              >
                Hapus
              </Button>
            </div>
          </div>
        </Modal.Footer>
      </Modal>
    </>
  );
}

export default Action;
